module.exports = __webpack_public_path__ + "static/media/metc.fdc979d3.gif";